import { render } from "./EventDetails.vue?vue&type=template&id=69fe7818&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-69fe7818"

export default script